import { createPartyRequest } from './helper';
export const getParties = createPartyRequest({
    route: '/party/parties',
    method: 'get',
    source: 'data',
});
